import { SelectOptionsType } from 'plataforma-fundacao-componentes/dist/components/select/Select';

export function objectToSelectOptions(
  cod: string | number,
  name: string
): SelectOptionsType {
  return {
    label: `${cod} - ${name}`,
    value: cod,
  };
}
